var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"kst-button",class:_vm.AppCatalog.Router.Forward.Class,attrs:{"icon-left":_vm.AppCatalog.Router.Forward.Icon,"label":_vm.AppCatalog.Router.Forward.Label},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }